<template>
  <div class="box">
    <!-- 顶部背景图 -->
    <div class="top">
      <div class="t-t1">新闻中心</div>
      <div class="t-t2box">
        <div class="t-t2">聚焦营销新动态 发掘行业新商机</div>
      </div>
    </div>

    <div class="box1">
      <!-- 左边 -->
      <div class="boxleft">
        <div class="item" @click="goNewX">
          <!-- 标题 -->
          <div class="le1">
            <div class="title">2022年百度渠道生态合作部展示类分销商引入告知函2022 年百度渠道生态合作部展示类分销商引入告知函</div>
            <div class="time">2022-06-15</div>
          </div>
          <!-- 图片 -->
          <div class="img">
            <img src="@/image/more/news/tu1@2x.png" alt="" />
          </div>
        </div>
        <div class="item">
          <!-- 标题 -->
          <div class="le1">
            <div class="title">2022年百度渠道生态合作部展示类分销商引入告知函2022 年百度渠道生态合作部展示类分销商引入告知函</div>
            <div class="time">2022-06-15</div>
          </div>
          <!-- 图片 -->
          <div class="img">
            <img src="@/image/more/news/tu2@2x.png" alt="" />
          </div>
        </div>
        <div class="item">
          <!-- 标题 -->
          <div class="le2">
            <div class="title">2022年百度渠道生态合作部展示类分销商引入告知函2022 年百度渠道生态合作部展示类分销商引入告知函</div>
            <div class="time">2022-06-15</div>
          </div>
        </div>
        <div class="item">
          <!-- 标题 -->
          <div class="le2">
            <div class="title">2022年百度渠道生态合作部展示类分销商引入告知函2022 年百度渠道生态合作部展示类分销商引入告知函</div>
            <div class="time">2022-06-15</div>
          </div>
        </div>
        <div class="item">
          <!-- 标题 -->
          <div class="le2">
            <div class="title">2022年百度渠道生态合作部展示类分销商引入告知函2022 年百度渠道生态合作部展示类分销商引入告知函</div>
            <div class="time">2022-06-15</div>
          </div>
        </div>
        <div class="item">
          <!-- 标题 -->
          <div class="le2">
            <div class="title">2022年百度渠道生态合作部展示类分销商引入告知函2022 年百度渠道生态合作部展示类分销商引入告知函</div>
            <div class="time">2022-06-15</div>
          </div>
        </div>
        <div class="item">
          <!-- 标题 -->
          <div class="le1">
            <div class="title">2022年百度渠道生态合作部展示类分销商引入告知函2022 年百度渠道生态合作部展示类分销商引入告知函</div>
            <div class="time">2022-06-15</div>
          </div>
          <!-- 图片 -->
          <div class="img">
            <img src="@/image/more/news/tu1@2x.png" alt="" />
          </div>
        </div>
        <div class="item">
          <!-- 标题 -->
          <div class="le1">
            <div class="title">2022年百度渠道生态合作部展示类分销商引入告知函2022 年百度渠道生态合作部展示类分销商引入告知函</div>
            <div class="time">2022-06-15</div>
          </div>
          <!-- 图片 -->
          <div class="img">
            <img src="@/image/more/news/tu1@2x.png" alt="" />
          </div>
        </div>
      </div>

      <!-- 右边 -->
      <div class="boxright">
        <div class="topp">为您推荐</div>

        <div class="item2">
          <img src="@/image/more/news/tu4@2x.png" alt="" />

          <div class="le2">
            <div class="title">2022年百度渠道生态合作部展示类分销商引入告知函</div>
            <div class="time">2022-06-15</div>
          </div>
        </div>

        <div class="item3">
          <div class="le2">
            <div class="title">2022年百度渠道生态合作部展示类分销商引入告知函</div>
            <div class="time">2022-06-15</div>
          </div>
        </div>

        <div class="item3">
          <div class="le2">
            <div class="title">2022年百度渠道生态合作部展示类分销商引入告知函</div>
            <div class="time">2022-06-15</div>
          </div>
        </div>

        <div class="item2">
          <img src="@/image/more/news/tu4@2x.png" alt="" />

          <div class="le2">
            <div class="title">2022年百度渠道生态合作部展示类分销商引入告知函</div>
            <div class="time">2022-06-15</div>
          </div>
        </div>

        <div class="item3">
          <div class="le2">
            <div class="title">2022年百度渠道生态合作部展示类分销商引入告知函</div>
            <div class="time">2022-06-15</div>
          </div>
        </div>

        <div class="item3">
          <div class="le2">
            <div class="title">2022年百度渠道生态合作部展示类分销商引入告知函</div>
            <div class="time">2022-06-15</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AaacuxxIndex',

  data() {
    return {}
  },

  mounted() {},

  methods: {
    goNewX() {
      this.$router.push('/newsx')
    },
  },
}
</script>

<style lang="scss" scoped>
.box {
  width: 100%;
}

// 顶部
.top {
  z-index: -1;
  position: relative;
  height: 480px;
  background-image: url('@/image/more/banner@2x.png');
  background-repeat: no-repeat;

  .t-t1 {
    font-size: 60px;
    color: #000;
    position: absolute;
    z-index: 100;
    top: 28%;
    left: 20%;
  }

  .t-t2box {
    padding-left: 5px;
    color: #666666;
    z-index: 100;
    position: absolute;
    top: 48%;
    left: 20%;
    .t-t2 {
      font-size: 24px;
      margin: 10px 0;
    }
  }
}

.box1 {
  width: 72%;
  height: 1520px;
  display: flex;
  margin: 60px auto;
  // background-color: #fafafa;
  padding-left: 180px;

  .boxleft {
    width: 820px;
    height: 100%;
    padding-top: 3px;

    margin-right: 60px;

    .item {
      box-shadow: 50px 10px 100px 5px #fafafa;
      // box-shadow: -3px -3px 3px 3px #fafafa;
      position: relative;
      width: 820px;
      height: 160px;
      // border: 1px solid;
      border-radius: 4px;

      margin-bottom: 10px;
      background-color: #ffffff;

      .le1 {
        margin-left: 15px;
        top: 25px;
        position: absolute;
        width: 500px;
        height: 108px;
        .title {
          line-height: 28px;
          letter-spacing: 1px;
          font-size: 18px;
        }
        .time {
          position: absolute;
          bottom: 0;
          color: #999999;
        }
      }

      .le2 {
        margin-left: 15px;
        top: 25px;
        position: absolute;
        width: 750px;
        height: 108px;
        .title {
          line-height: 28px;
          letter-spacing: 1px;
          font-size: 18px;
        }
        .time {
          position: absolute;
          bottom: 0;
          color: #999999;
        }
      }

      .img {
        top: 10px;
        position: absolute;
        right: 10px;
      }
    }
  }

  .boxright {
    margin-top: 5px;
    box-shadow: 0px 1px 10px 10px #fafafa;
    // box-shadow-right:
    width: 345px;
    height: 89%;
    box-sizing: border-box;
    padding-left: 22px;
    border-radius: 12px;
    .topp {
      font-size: 22px;
      margin-top: 20px;
      margin-bottom: 30px;
    }
    .item2 {
      position: relative;
      height: 310px;
      margin-bottom: 20px;

      .le2 {
        // top: 25px;
        position: absolute;
        width: 285px;
        height: 112px;
        border-bottom: 2px solid #fafafa;
        .title {
          color: #333333;

          letter-spacing: 1px;
          font-size: 16px;
        }
        .time {
          position: absolute;
          bottom: 20px;
          color: #999999;
        }
      }

      img {
        width: 300px;
        height: 180px;
        margin-bottom: 15px;
      }
    }

    .item3 {
      position: relative;
      height: 112px;
      margin-bottom: 30px;

      .le2 {
        // top: 25px;
        position: absolute;
        width: 285px;
        height: 112px;
        border-bottom: 2px solid #fafafa;
        .title {
          color: #333333;

          letter-spacing: 1px;
          font-size: 16px;
        }
        .time {
          position: absolute;
          bottom: 20px;
          color: #999999;
        }
      }
    }
  }
}
</style>
